import { render, staticRenderFns } from "./EnablingTypesRegistryNewForm.vue?vue&type=template&id=4a9f2b77"
import script from "./EnablingTypesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./EnablingTypesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports